import { render, staticRenderFns } from "./seminarStatistics.vue?vue&type=template&id=7bf1bfd0&scoped=true&"
import script from "./seminarStatistics.vue?vue&type=script&lang=js&"
export * from "./seminarStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf1bfd0",
  null
  
)

export default component.exports